import { useState } from "react";
import { Check, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";
import { PLANS } from "../../data/content";
import { formatCOP } from "../../lib/api";

export const Pricing = ({ onEnroll }) => {
  const [installments, setInstallments] = useState(false);

  const scrollToContact = () => document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="precios" data-testid="pricing-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-xs uppercase font-mono tracking-[0.28em] text-emerald-600 dark:text-emerald-400 font-semibold mb-4">Inversión</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Precios claros, <span className="font-serif italic text-emerald-500">sin letra pequeña</span>
          </h2>
          <div className="mt-8 inline-flex items-center rounded-full border border-border bg-card p-1.5 gap-1">
            <button
              data-testid="billing-toggle-single"
              onClick={() => setInstallments(false)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-all ${!installments ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground"}`}
            >
              Pago único
            </button>
            <button
              data-testid="billing-toggle-installments"
              onClick={() => setInstallments(true)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-all ${installments ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground"}`}
            >
              3 cuotas sin interés
            </button>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6 items-stretch">
          {PLANS.map((plan, i) => (
            <Reveal key={plan.id} delay={i * 0.1} className="h-full">
              <div
                data-testid={`pricing-card-${plan.id}`}
                className={`relative rounded-3xl border p-8 h-full flex flex-col transition-all duration-300 hover:-translate-y-1.5 ${
                  plan.featured
                    ? "border-emerald-500/60 bg-card shadow-[0_24px_60px_rgba(16,185,129,0.18)]"
                    : "border-border bg-card hover:border-emerald-500/40 hover:shadow-[0_20px_50px_rgba(16,185,129,0.1)]"
                }`}
              >
                {plan.featured && (
                  <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-emerald-500 text-white text-[11px] font-semibold px-4 py-1.5 shadow-lg shadow-emerald-500/30">
                    <Sparkles className="w-3.5 h-3.5" /> Más elegido
                  </span>
                )}
                <h3 className="font-display text-xl font-semibold tracking-tight">{plan.name}</h3>
                <p className="text-sm text-muted-foreground mt-1.5">{plan.tagline}</p>

                <div className="mt-6 min-h-[64px]">
                  {plan.price ? (
                    <>
                      <p data-testid={`pricing-amount-${plan.id}`} className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight">
                        {formatCOP(installments ? plan.installments : plan.price)}
                      </p>
                      <p className="text-xs text-muted-foreground mt-1">{installments ? "por cuota · 3 cuotas" : "pago único"}</p>
                    </>
                  ) : (
                    <p className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight">A cotizar</p>
                  )}
                </div>

                <ul className="mt-7 space-y-3 flex-1">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm">
                      <Check className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`pricing-cta-${plan.id}`}
                  onClick={() => plan.price ? onEnroll({ course: plan.name, plan: installments ? "3 cuotas sin interés" : "Pago único" }) : scrollToContact()}
                  className={`mt-8 w-full rounded-full font-semibold py-3.5 text-sm transition-all active:scale-[0.98] ${
                    plan.featured
                      ? "bg-primary text-primary-foreground hover:brightness-110 shadow-lg shadow-emerald-500/25"
                      : "border border-border hover:border-primary/60 hover:text-foreground text-muted-foreground"
                  }`}
                >
                  {plan.price ? "Inscribirme" : "Hablar con un asesor"}
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
